<template>
  <label class="switch" :class="[disabled === true ? 'disabled' : '', variant]">
    <input
      type="checkbox"
      :disabled="disabled"
      @change="onChange"
      :checked="isChecked"
    />
    <span class="slider round" @click.stop="click"></span>
  </label>
</template>
<script>
export default {
  data() {
    return {};
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },

    modelValue: {
      default: null,
    },

    disableChild: {
      default: false,
    },
    checked: {
      default: false,
    },
    clickEvents: {
      default: null,
    },
    clickParam: {
      default: null,
    },
    variant: {
      default: "",
    },
  },

  methods: {
    onChange(e) {
      if (!this.disableChild) {
        if (this.modelValue !== null) {
          this.$emit("update:modelValue", e.target.checked);
        }
      }
    },
    click(e) {
      e.stopPropagation();
      if (this.clickEvents) {
        this.clickEvents(this.clickParam);
      }
    },
  },
  computed: {
    isChecked() {
      if (this.modelValue !== null) {
        return this.modelValue;
      }
      return this.checked;
    },
  },
};
</script>
